export const ServiceLabel = ({ name }) => {
  return <div className="service_label">{name}</div>;
};
